export default "__VITE_ASSET__DWvp9n92__"